import { useState, useEffect } from 'react';
import useWindowSize from './useWindowSize';

const useIsContained = (parentRef: any, childRef: any) => {
  const [isContained, setIsContained] = useState(false);
  const windowSize = useWindowSize();

  useEffect(() => {
    const parentRect = parentRef.current.getBoundingClientRect();
    const childRect = childRef.current.getBoundingClientRect();

    setIsContained(
      childRect.left >= parentRect.left &&
        childRect.right <= parentRect.right &&
        childRect.top >= parentRect.top &&
        childRect.bottom <= parentRect.bottom,
    );
  }, [windowSize, parentRef, childRef]);

  return isContained;
};

export default useIsContained;
